import { useMemo } from 'react';
import type {
  ComputeCaseDto,
  ListComputeSettingsModelDto,
  ModelAreaDto,
} from '../../../../../../api/generated';
import { getObjectEstimationAvailability } from '../../../../utils/objectCaseUtils';

export const useObjectEstimationAvailability = (
  objectEstimationCases: ComputeCaseDto[],
  allModelAreas: ModelAreaDto[],
  allArchelSettings: ListComputeSettingsModelDto[] | null | undefined,
  currentCaseId: string,
) =>
  useMemo(
    () =>
      getObjectEstimationAvailability(
        objectEstimationCases,
        allModelAreas,
        allArchelSettings,
        currentCaseId,
      ),
    [objectEstimationCases, allModelAreas, allArchelSettings, currentCaseId],
  );
